import type { GlobalMessageHandler } from '@atlassian/eoc-global-context';

import type { WhoIsOnCallMessage, WhoIsOnCallWidgetMessage } from './types';

const urls: Readonly<{
	readonly schedules: {
		readonly onCalls: {
			readonly url: () => string;
		};
		readonly scheduleId: {
			readonly timeline: {
				readonly url: ({ scheduleId }?: { scheduleId: string }) => string;
			};
			readonly url: ({ scheduleId }?: { scheduleId: string }) => string;
		};
		readonly url: () => '/v1/schedules';
		readonly user: {
			readonly timeline: {
				readonly export: {
					readonly url: () => string;
				};
				readonly url: () => string;
			};
			readonly url: () => string;
			readonly userId: {
				readonly url: ({ userId }?: { userId: string }) => string;
			};
		};
	};
	readonly teams: {
		readonly url: () => '/v1/teams';
	};
	readonly wioc: {
		readonly status: {
			readonly url: () => string;
		};
	};
}> = Object.freeze({
	schedules: {
		url: (): '/v1/schedules' => `/v1/schedules`,
		user: {
			url: (): string => `${urls.schedules.url()}/user`,
			timeline: {
				url: (): string => `${urls.schedules.user.url()}/timeline`,
				export: {
					url: (): string => `${urls.schedules.user.timeline.url()}/export`,
				},
			},
			userId: {
				url: (
					{
						userId,
					}: {
						userId: string;
					} = {
						userId: ':userId',
					},
				): string => `${urls.schedules.user.url()}/${userId}`,
			},
		},
		onCalls: {
			url: (): string => `${urls.schedules.url()}/on-calls`,
		},
		scheduleId: {
			url: (
				{
					scheduleId,
				}: {
					scheduleId: string;
				} = {
					scheduleId: ':scheduleId',
				},
			): string => `${urls.schedules.url()}/${scheduleId}`,
			timeline: {
				url: (
					{
						scheduleId,
					}: {
						scheduleId: string;
					} = {
						scheduleId: ':scheduleId',
					},
				): string => `${urls.schedules.scheduleId.url({ scheduleId })}/timeline`,
			},
		},
	},
	wioc: {
		status: {
			url: (): string => `${urls.schedules.url()}/user/on-calls`,
		},
	},
	teams: {
		url: (): '/v1/teams' => `/v1/teams`,
	},
} as const);

export const SPOTLIGHT_NAMES = {
	firstOverlappingPeriod: 'eoc-who-is-on-call_first_overlapping_period',
};

export const SPOTLIGHT_TOURS = {
	overlappingPeriod: 'eoc-who-is-on-call-overlapping-period',
};

export { urls };

export class WhoIsOnCallHandler implements GlobalMessageHandler<unknown> {
	handler(message: WhoIsOnCallMessage, context?: unknown): void {
		throw new Error('Not implemented');
	}
}

export class WhoIsOnCallWidgetHandler implements GlobalMessageHandler<unknown> {
	handler(message: WhoIsOnCallWidgetMessage, context?: unknown): void {
		throw new Error('Not implemented');
	}
}
